import React from 'react';
import Icon from './Icon';

export default Icon(
  <g>
    <rect
      height="6"
      width="6"
      x="21"
      y="38"
    />
    <rect
      height="31"
      width="6"
      x="21"
      y="4"
    />
  </g>, '0 0 48 48', 'InfoIcon',
);
